export default __webpack_public_path__ + "static/media/WhoEatsWhat_00.cb814ea7.png";